import { DialogTitle, Grid, IconButton } from '@material-ui/core';
import { Icons, Typography } from '@nutrien/cxp-components';
import React from 'react';

import useStyles from './GenericSidePanelHeader.styles';

interface Props {
  onClose: () => void;
  title: string;
}

const GenericSidePanelHeader: React.FC<Props> = ({ onClose, title }: Props) => {
  const classes = useStyles();

  return (
    <DialogTitle disableTypography className={classes.root}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item className={classes.emptyGrid} />
        <Grid item>
          <Typography variant="h6" color="inherit">
            {title}
          </Typography>
        </Grid>
        <Grid item>
          <IconButton data-testid="gsp-close" aria-label="close" onClick={onClose}>
            <Icons.XFeather strokeWidth={1} color="primary" />
          </IconButton>
        </Grid>
      </Grid>
    </DialogTitle>
  );
};

export default GenericSidePanelHeader;
